/* eslint-disable no-unused-vars */
import Vue from 'vue'

const state = {
  proposta: {},
  rateioRow: [],
  cnpjInput: null,
  checkOsConstituicao: false,
}

const getters = {
  proposta: state_ => state_.proposta,
  getStatusProposta: state_ => state_.proposta.eStatusProposta,
  getCheckOsConstituicao: state_ => state_.checkOsConstituicao,
  rateioRow: state_ => state_.rateioRow,
  existeMaisDeUmContratante: state_ => state_.proposta && state_.proposta.empresasVinculadas && state_.proposta.empresasVinculadas.length > 1,
  getRateioEmpresasServicos: state_ => {
    const empresas = !state_.proposta ? null : state_.proposta.empresasVinculadas
    const servicos = !state_.proposta ? null : state_.proposta.servicosAdicionais
    const pacote = !state_.proposta ? null : state_.proposta.propostasPacotes[0]

    if (!empresas || !servicos || !pacote) return state_.rateioRow

    pacote.servicos.forEach(servico => {
      const value = {
        idPacote: pacote.id,
        nome: servico.nome,
        subTotal: (servico.valorAuditar + pacote.acrescimoPacote) - pacote.descontoPacote,
        diferencia: ((servico.valorAuditar + pacote.acrescimoPacote) - pacote.descontoPacote) !== 0,
        children: empresas.map(empresa => {
          const valueEmpresa = {
            idEmpresa: empresa.empresaResumida.id,
            nome: `${empresa.empresaResumida.cadastroFederal} - ${empresa.empresaResumida.razaoSocial}`,
            subTotal: 0,
          }
          return valueEmpresa
        }),
      }
      state_.rateioRow.push(value)
    })

    servicos.forEach(servico => {
      if (servico.id) {
        const value = {
          idServico: servico.id,
          nome: servico.servico.nome,
          diferencia: ((servico.valorAuditar + servico.acrescimo) - servico.desconto) !== 0,
          subTotal: (servico.valorAuditar + servico.acrescimo) - servico.desconto,
          children: empresas.map(empresa => {
            const valueEmpresa = {
              idEmpresa: empresa.empresaResumida.id,
              nome: `${empresa.empresaResumida.cadastroFederal} - ${empresa.empresaResumida.razaoSocial}`,
              subTotal: 0,
            }
            return valueEmpresa
          }),
        }
        state_.rateioRow.push(value)
      }
    })
    return state_.rateioRow
  },
  vinculadoContratoOmieEmpresa: state_ => {
    const empresas = !state_.proposta ? null : state_.proposta.empresasVinculadas

    if (!empresas) return false

    return !empresas.some(some => some.eStatusOmieContrato === 3 || some.eStatusOmieContrato === 0)
  },
  getCnpjInput: state_ => state_.cnpjInput,

  getTodosServicos: state_ => {
    const statusFatu = {
      1: 'Aguardando',
      2: 'Liberado',
    }
    let servicos
    if (state_.proposta.servicos.some(s => s.servico)) {
      servicos = state_.proposta.servicos?.map(servico => {
        const newServico = {
          id: servico.proposta_ServicoId.toString(),
          nome: servico.servico?.nome,
          statusFaturamento: statusFatu[servico.statusFaturamento],
          usuCadastro: servico.usuAlteracaoStatusFaturamento || '',
          dataCadastro: servico.dataAlteracaoStatusFaturamento || '',
          isServicoPacote: false,
        }
        return newServico
      })
    }

    let servicosAdicionais
    if (state_.proposta.servicosAdicionais.some(s => s.servico)) {
      servicosAdicionais = state_.proposta.servicosAdicionais?.map(servico => {
        const newServicoAdicional = {
          id: servico.proposta_ServicoId.toString(),
          nome: servico.servico?.nome,
          statusFaturamento: statusFatu[servico.statusFaturamento],
          usuCadastro: servico.usuAlteracaoStatusFaturamento || '',
          dataCadastro: servico.dataAlteracaoStatusFaturamento || '',
          isServicoPacote: false,
        }
        return newServicoAdicional
      })
    }

    const servicosPacotes = state_.proposta.propostasPacotes[0].servicos?.map(servico => {
      const newServicoPacote = {
        id: servico.proposta_PacoteServicoId.toString(),
        nome: servico?.nome,
        statusFaturamento: statusFatu[servico.statusFaturamento],
        usuCadastro: servico.usuAlteracaoStatusFaturamento || '',
        dataCadastro: servico.dataAlteracaoStatusFaturamento || '',
        isServicoPacote: true,
      }
      return newServicoPacote
    })
    let returno = []
    returno = returno.concat(servicos, servicosAdicionais, servicosPacotes).filter(item => item !== undefined)
    return returno
  },
}

const actions = {
  setProposta({ commit }, proposta) {
    commit('SET_PROPOSTA', proposta)
  },
  limparRateio({ commit }) {
    commit('SET_RATEIO', [])
  },
  updateRateioRow({ commit }, rateio) {
    commit('ATUALIZA_RATEIO', rateio)
  },
  setRateioRow({ commit }, rateio) {
    commit('SET_RATEIO', rateio)
  },
  setCnpjInput({ commit }, cnpj) {
    commit('SET_CNPJ_INPUT', cnpj)
  },
  setCheckOsConstituicao({ commit }, valor) {
    commit('SET_CHECK_CONSTITUICAO', valor)
  },
}

const mutations = {
  SET_PROPOSTA(state_, proposta) {
    Vue.set(state_, 'proposta', proposta)
  },
  SET_RATEIO(state_, rateio) {
    Vue.set(state_, 'rateioRow', rateio)
  },
  ATUALIZA_RATEIO(state_, payload) {
    Vue.set(state_.rateioRow[payload.index], 'diferencia', false)
  },
  SET_CNPJ_INPUT(state_, cnpj) {
    Vue.set(state_, 'cnpjInput', cnpj)
  },
  SET_CHECK_CONSTITUICAO(state_, valor) {
    Vue.set(state_, 'checkOsConstituicao', valor)
  },
}

export default {
  namespaced: true,
  getters,
  actions,
  mutations,
  state: () => state,
}
